// enums with string values don't have reverse mapping.
export function getEnumKeyByEnumValue(myEnum: { [key: string]: string }, enumValue: string) {
  const keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
  return keys.length > 0 ? keys[0] : null;
}
